// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  background: var(--base-color-white, #FFF);
  width: 52rem;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100vh;
}
:host .divider {
  width: 100%;
  height: 0.1rem;
  background: var(--primary-10);
  display: inline-block;
  flex: none;
}
:host .side-panel-wrap {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  border-left: 1px solid var(--separators-colors-secondary, #E1E1E1);
  background: var(--bg);
}
:host .side-panel-wrap .side-panel-content {
  display: flex;
  flex: 1 1 auto;
  padding: 4rem 4rem 0 4rem;
  overflow: auto;
}

.side-panel-footer {
  flex: none;
  bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./src/shared/overlay-side-panel/components/overlay-side-panel/overlay-side-panel.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,yCAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;AACF;AACE;EACE,WAAA;EACA,cAAA;EACA,6BAAA;EACA,qBAAA;EACA,UAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,kEAAA;EACA,qBAAA;AAAJ;AAEI;EACE,aAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;AAAN;;AAKA;EACE,UAAA;EACA,WAAA;AAFF","sourcesContent":[":host {\n  display: block;\n  background: var(--base-color-white, #FFF);\n  width: 52rem;\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  height: 100vh;\n\n  .divider {\n    width: 100%;\n    height: 0.1rem;\n    background: var(--primary-10);\n    display: inline-block;\n    flex: none;\n  }\n\n  .side-panel-wrap {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    min-height: 0;\n    border-left: 1px solid var(--separators-colors-secondary, #E1E1E1);\n    background: var(--bg);\n\n    .side-panel-content {\n      display: flex;\n      flex: 1 1 auto;\n      padding: 4rem 4rem 0 4rem;\n      overflow: auto;\n    }\n  }\n}\n\n.side-panel-footer {\n  flex: none;\n  bottom: 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
